"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.swaggerRef = void 0;
function swaggerRef(type, isArray) {
  if (isArray) {
    return {
      type: typeof type === "string" ? Object : () => type,
      nullable: true,
      required: false,
      isArray: true,
      items: {
        $ref: "#/components/schemas/" + (typeof type === "string" ? type : type.name)
      },
      example: null
    };
  }
  return {
    type: typeof type === "string" ? Object : () => type,
    nullable: true,
    required: false,
    isArray: !!isArray || undefined,
    oneOf: [{
      type: "null"
    }, {
      $ref: "#/components/schemas/" + (typeof type === "string" ? type : type.name)
    }],
    example: null
  };
}
exports.swaggerRef = swaggerRef;
